import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';

interface LanguageSelectorProps {
  onLanguageChange?: () => void;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ onLanguageChange }) => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    if (onLanguageChange) {
      onLanguageChange();
    }
  };

  const getCurrentLanguageName = () => {
    switch (i18n.language) {
      case 'es':
        return 'Español';
      case 'en':
        return 'English';
      default:
        return 'English';
    }
  };

  const getCurrentLanguageFlag = () => {
    switch (i18n.language) {
      case 'es':
        return '🇪🇸';
      case 'en':
        return '🇺🇸';
      default:
        return '🇺🇸';
    }
  };

  return (
    <Dropdown>
      <Dropdown.Toggle variant="outline-secondary" id="dropdown-language" className="text-white border-white">
        <FontAwesomeIcon icon={faGlobe as any} className="me-2" />
        {getCurrentLanguageFlag()} {getCurrentLanguageName()}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => changeLanguage('en')}>
          🇺🇸 English
        </Dropdown.Item>
        <Dropdown.Item onClick={() => changeLanguage('es')}>
          🇪🇸 Español
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageSelector; 